export default "__VITE_ASSET__bBR2a$hU__"